import { render, staticRenderFns } from "./MountainGame.vue?vue&type=template&id=5f286242&"
import script from "./MountainGame.vue?vue&type=script&lang=js&"
export * from "./MountainGame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports